<template>
  <div class="home">
    <div class="head-title">发票申请</div>
    <div class="">
      <div class="">
        <div class="tianjia">
          <nav class="navbar">
            <div class="nav-l">
              <el-button type="primary" icon="el-icon-plus" @click="chuangj"
                >添加</el-button
              >
              <el-select
                style="margin-left: 24px; min-width: auto; width: 24.0rem"
                clearable
                v-model="values"
                placeholder="请选择状态"
                @change="abc"
              >
                <el-option
                  v-for="item in optionss"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-date-picker
                style="margin-left: 24px"
                v-model="value2"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="right"
                @change="onSubmit"
              ></el-date-picker>
            </div>
          </nav>
          <el-table
            :data="tableData.data"
            
            border
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            style="width: 100%; text-aligh: center; margin-top: 2.0rem"
          >
            <el-table-column
              prop="money"
              label="审核的金额"
              min-width="100"
            ></el-table-column>
            <el-table-column
              prop="content"
              label="消费说明"
              min-width="200"
              show-overflow-tooltip=""
            ></el-table-column>
            <el-table-column
              prop="account"
              label="代理商名称"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="phone"
              label="代理商手机号"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="province"
              label="代理商归属省份"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="city"
              label="代理商归属市区"
              width="120"
            ></el-table-column>
            <el-table-column prop="enterprisePhoto" label="营业执照">
              <template slot-scope="scope">
                <img
                  :src="scope.row.enterprisePhoto"
                  alt=""
                  style="width: 10.0rem"
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="check_content"
              label="审核内容"
              width="140"
              show-overflow-tooltip=""
            ></el-table-column>
            <el-table-column
              prop="user_username"
              label="审核人"
              width="160"
              show-overflow-tooltip=""
            ></el-table-column>
            <el-table-column prop="status_name" label="状态" width="100">
              <template slot-scope="scope">
                <div v-if="scope.row.status == 2" style="color: #34bb4d">
                  已完成
                </div>
                <div v-if="scope.row.status == 3" style="color: #d91a1a">
                  驳回
                </div>
                <div v-if="scope.row.status == 1" style="color: #46aaf6">
                  待审核
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="addtime"
              label="申请时间"
              width="160"
            ></el-table-column>
            <el-table-column label="操作" fixed="right" width="120">
              <template slot-scope="scope">
                <div v-if="scope.row.status == 1 || scope.row.status == 3">
                  <el-button
                    @click="bianji(scope.row)"
                    type="text"
                    size="mini"
                    >详情</el-button
                  >
                </div>
                <div v-if="scope.row.status == 2">
                  <el-button
                    @click="bianjis(scope.row)"
                    type="text"
                    size="mini"
                    >详情</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="paging">
            <pagination
              :total="tableData.total"
              :page.sync="listQuery.page"
              :limit.sync="listQuery.limit"
              :page-sizes="[10,20,50,100]"
              @pagination="abc"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import qs from "qs";
export default {
  data() {
    return {
      tableData: {
        total: 0,
        data: [],
      },
      url: "https://api.weijub.com",
      username: {},
      title: {},
      czphone: "",
      optionss: [
        {
          value: "1",
          label: "待审核 ",
        },
        {
          value: "2",
          label: "已完成 ",
        },
        {
          value: "3",
          label: "拒绝 ",
        },
      ],
      values: "",
      onSubmitn: false,
      value2: "",
      start_time: "",
      end_time: "",
      listQuery: {
        page: 1,
        limit: 20,
      },
    };
  },
  mounted() {
    // if (window.sessionStorage.getItem("title")) {
    //   let title = JSON.parse(window.sessionStorage.getItem("title"));
    //   this.title = title;
    //   var a = document.title;
    //   document.title = title[0].website + "-" + a;
    // }
    if (window.sessionStorage.getItem("userinfo")) {
      let userinfo = JSON.parse(window.sessionStorage.getItem("userinfo"));
      this.username = userinfo;
    }
    this.abc();
  },
  methods: {
    chuangj() {
      this.$router.push({
        name: "invoice",
      });
    },
    bianjis(val) {
      this.$router.push({
        name: "invoicedss",
        query: {
          val,
        },
      });
    },
    bianji(val) {
      this.$router.push({
        name: "invoiceParticulars",
        query: {
          val,
        },
      });
    },
    onSubmit() {
      if (this.value2!==null&&this.value2.length) {
        this.start_time = new Date(this.value2[0]).getTime();
        this.end_time = new Date(this.value2[1]).getTime();
      } else {
        this.start_time = "";
        this.end_time = "";
      }

      this.abc();
    },
    // tooken验证
    handleCurrentChange(val) {
      this.axios
        .post(
          "/api/record/getRecordList",
          qs.stringify({
            totaltoken: this.tooken.totaltoken,
            page: val,
            type: this.value,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
    abc() {
      this.axios
        .post(
          "/api/Agent/getApplyInvoiceAgent",
          qs.stringify({
            agent_id: this.username.id,
            agenttoken: this.username.agenttoken,
            page: this.listQuery.page,
            number_page:this.listQuery.limit,
            status: this.values,
            start_time: this.start_time,
            end_time: this.end_time,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
  },
  // 1.用户分配
};
</script>
<style scoped>
h1 {
  font-size: 26px;
  font-weight: 500;
  color: #393939;
  font-family: "黑软雅黑";
}

.el-table .thea {
  color: #333333;
  font-size: 18px;
}
.el-dialog__header {
  /* height: 69px; */
  background-color: #2890dd;
}
.el-dialog__title {
  color: #ffffff !important;
  /* font-size: 2.0rem !important; */
}
.el-dialog__headerbtn .el-dialog__close {
  color: #ffffff !important;
}
</style>
<style lang="scss" scoped>
::v-deep .el-table thead {
  color: #ffffff;
}
.home {
  padding: 2rem;
  border-radius: .8rem;
  box-shadow: .3rem .3rem 2rem 0 rgba(0, 0, 0, 0.1);
}
.body_html {
  width: 100%;
  height: 100%;
}
.wei_body {
  margin-top: 2.0rem;
  width: 100%;
  height: 90%;
  background-color: #ffffff;
  box-shadow: .0rem .1rem 0.6rem .0rem rgba(0, 0, 0, 0.2);
  padding: 1.0rem 3.1rem;
}
.tianjia {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  position: relative;
}
.tianjia > main {
  font-size: 26px;
  /* margin-bottom: 4.0rem; */
}
.bule {
  width: 100%;
  height: 6.9rem;
  background-color: #2890dd;
  z-index: 10;
  position: absolute;
  top: .0rem;
  left: .0rem;
}
.el-form-item {
  display: inline-block;
}
</style>